module.exports = __webpack_public_path__ + "static/media/development-blog-2.60b59f82.md";